module.exports = __webpack_public_path__ + "static/img/10011 (2).466290b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10011 (2).webp
// module id = 42Ac
// module chunks = 14